import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react';
import { AsyncSelect } from '@landsvirkjun/react.common';
import { useSearchEmployeeQuery } from 'api/services/TravelForm';
import { EmployeeData } from 'api/types/types';
import { useNavigate } from 'react-router-dom';
import { ApproversListResult } from 'api/services/Admin';

type ApproverSearchProps = {
  approversList: ApproversListResult[];
};

export const ApproverSearch = ({
  approversList,
}: ApproverSearchProps): JSX.Element => {
  const navigate = useNavigate();
  const { mutateAsync } = useSearchEmployeeQuery();
  const [approver, setApprover] = useState('');
  // const [isAlreadyApprover, setIsAlreadyApprover] = useState(false);

  return (
    <Box as="div">
      <FormControl>
        {/* isInvalid={isAlreadyApprover}b */}
        <FormLabel>Stofna nýjan samþykkjenda</FormLabel>
        <AsyncSelect
          placeholder="Leita eftir starfsmanni"
          mutateAsync={mutateAsync}
          onChange={(value): void => {
            const employeeData = JSON.parse(value.value) as EmployeeData;
            //We ndee to be able to create the approver again
            // const findEmployee = approversList.find(
            //   (appr) => appr.employeeId === employeeData.ADUser
            // );
            // if (findEmployee) {
            //   setIsAlreadyApprover(true);
            //   setApprover(employeeData.Name);
            // } else {
            const newEmployeeData = {
              name: employeeData.Name,
              employeeId: employeeData.adUser,
              approvesDepartments: [],
            };
            navigate('/admin/samthykkjendur/action?mode=create', {
              state: { employeeData: newEmployeeData },
            });
            // }
          }}
          defaultValue={
            approver
              ? {
                  label: approver,
                  value: approver,
                }
              : null
          }
        />
        <FormErrorMessage>{approver} er nú þegar samþykkjandi</FormErrorMessage>
      </FormControl>
    </Box>
  );
};
